import { axiosInstance } from "libs/axiosInstance";
import { PostCheckVerificationCode, PostPhoneVerificationCode } from "./phone.schema";

/** 인증 코드 요청 POST */
export const postPhoneVerificationCode: PostPhoneVerificationCode = async ({ ...body }) => {
  const serverRes = await axiosInstance.post(`/account/phone`, body);
  return serverRes.data;
};

/** 코드 전송 및 업데이트 POST */
export const postCheckVerificationCode: PostCheckVerificationCode = async ({ ...body }) => {
  const serverRes = await axiosInstance.post(`/account/phone/verify`, body);
  return serverRes.data;
};
